import Model from "../classes/Model";
import CatalogApi from '../classes/api/Catalog';
import ValidationError from "../classes/ValidationError";

export default class Good extends Model {

    get id() {
        return this._id;
    }

    set name(value) {
        this._name = value;
    }
    get name() {
        return this._name;
    }

    set price(value) {
        this._price = value;
    }
    get price() {
        return this._price;
    }

    set comment(value) {
        this._comment = value;
    }
    get comment() {
        return this._comment;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
        return {
            id: this.id,
            name: this.name,
            price: this.price,
            comment: this.comment,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            name: data.name,
            price: data.price,
            comment: data.comment,
            createdAt: data.created_at,
            createdBy: data.created_by,
        };
    }

    static getList(page = 1, perPage = 10, sort = undefined) {
        return CatalogApi.getList(page, perPage, sort).then((response) => {
            let data = [];
            for (let trainer of response.data) {
                data.push(new this(this.toResponse(trainer)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return CatalogApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return CatalogApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new Good(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return CatalogApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}
